//cart-controller-custom.js

const CART_UPDATE_DURATION = 3000;
let isUpdatingCart = false;
let cartTimer = null;
let cartAnimReq = null;
let cartStartTime = null;


/* ================================
   BOTÓN CHECKOUT LOADING
================================ */
function setCheckoutLoadingState(isLoading) {
  const btn = document.querySelector('.cart-recap__checkout');
  if (!btn) return;

  if (isLoading) {
    btn.disabled = true;
    btn.style.cursor = 'not-allowed';
    btn.style.pointerEvents = 'none';
    btn.style.backgroundColor = '#999';
    btn.style.borderColor = '#999';
    btn.style.opacity = '0.85';
    btn.style.color = '#fff';
    btn.style.position = 'relative';
    btn.style.overflow = 'hidden';

    btn.innerHTML = `
      <span style="display:flex; align-items:center; justify-content:center; gap:8px;">
        <span class="loader" style="width:16px;height:16px;"></span>
        Actualizando carro...
      </span>
      <div id="cart-progress-bar" style="position:absolute; bottom:0; left:0; height:6px; background-color:#cf1b2b; width:0%; transition: width 50ms linear;"></div>
    `;
  } else {
    if (cartAnimReq) cancelAnimationFrame(cartAnimReq);
    btn.disabled = false;
    btn.style.cursor = 'pointer';
    btn.style.pointerEvents = 'auto';
    btn.style.backgroundColor = '';
    btn.style.borderColor = '';
    btn.style.opacity = '';
    btn.style.color = '';
    btn.style.position = '';
    btn.style.overflow = '';

    btn.innerHTML = 'Continuar pedido';
  }
}

/* ================================
   VALIDACIÓN CENTRAL
================================ */
function validateQuantity(input, value) {
  const min = parseInt(input.dataset.minimum) || 1;
  const stock = parseInt(input.dataset.stock) || 999999;

  if (isNaN(value)) value = min;
  if (value < min) value = min;
  if (value > stock) value = stock;

  return value;
}

/* ================================
   INPUT MANUAL
================================ */
document.addEventListener("input", function(e) {
  if (e.target && e.target.classList && e.target.classList.contains("custom-qty-input")) {
    e.target.value = e.target.value.replace(/\D/g, '');
  }
});

document.addEventListener("blur", function(e) {
  if (e.target && e.target.classList && e.target.classList.contains("custom-qty-input")) {
    handleManualInput(e.target);
  }
}, true);

function handleManualInput(input) {
  let value = parseInt(input.value);
  value = validateQuantity(input, value);

  const initialValue = parseInt(input.dataset.initial);

  input.value = value;

  const container = input.closest('.quantity-selector');
  const stock = parseInt(input.dataset.stock) || 999999;
  updateStockUI(container, value, stock);

  if (value === initialValue) return;

  input.dataset.initial = value;

  syncQuantity(input, value);
  triggerCartUpdate();
}

/* ================================
   BOTONES + / -
================================ */
document.addEventListener("click", function(e) {
  const btn = e.target.closest('.js-increase, .js-decrease');
  if (!btn) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const container = btn.closest('.quantity-selector');
  const input = container.querySelector('.custom-qty-input');

  const min = parseInt(input.dataset.minimum) || 1;
  const stock = parseInt(input.dataset.stock) || 999999;

  let value = parseInt(input.value) || min;

  if (btn.classList.contains("js-increase")) {
    value++;
  } else {
    value--;
  }

  value = validateQuantity(input, value);

  input.value = value;

  syncQuantity(input, value);
  updateStockUI(container, value, stock);
  triggerCartUpdate();
}, true);

/* ================================
   SYNC CON SISTEMA LEGACY
================================ */
function syncQuantity(input, value) {

  const lineItem = input.closest('.line-item');
  if (!lineItem) return;

  // actualizar dataset global
  lineItem.dataset.qtycart = value;

  // sincronizar TODOS los inputs visuales (mobile + desktop)
  lineItem.querySelectorAll('.custom-qty-input').forEach(el => {
    el.value = value;
    el.dataset.initial = value;
  });

  // sincronizar TODOS los hidden inputs legacy
  lineItem.querySelectorAll('.quantity_update').forEach(el => {
    el.value = value;
    el.setAttribute('data-current-value', value);
  });

  // actualizar botones +/- de TODOS los bloques
  lineItem.querySelectorAll('.quantity-selector').forEach(container => {
    updateQuantityButtons(container, value);
  });
}

function updateQuantityButtons(container, value) {

  const input = container.querySelector('.custom-qty-input');
  if (!input) return;

  const stock = parseInt(input.dataset.stock) || 999999;

  const increaseBtn = container.querySelector('.js-increase');
  const decreaseBtn = container.querySelector('.js-decrease');

  if (increaseBtn) {

    if (value >= stock) {

      increaseBtn.disabled = true;
      increaseBtn.setAttribute('aria-label', 'No queda stock');
      increaseBtn.setAttribute('data-tooltip', 'No queda stock');
      increaseBtn.setAttribute('data-tooltip-position', 'bottom-left');

      increaseBtn.classList.add('is-disabled-stock');

    } else {

      increaseBtn.disabled = false;
      increaseBtn.removeAttribute('data-tooltip');

      increaseBtn.classList.remove('is-disabled-stock');
    }
  }

  if (decreaseBtn) {

    if (value <= 1) {
      decreaseBtn.disabled = true;
    } else {
      decreaseBtn.disabled = false;
    }
  }
}

/* ================================
   BLOQUEAR ENTER
================================ */
document.addEventListener("keydown", function(e) {
  if (
    e.target && e.target.classList &&
    e.target.classList.contains("custom-qty-input") &&
    e.key === "Enter"
  ) {
    // e.preventDefault();
    handleManualInput(e.target);
    // e.stopImmediatePropagation();
    // return false;
  }
});

/* ================================
   TRIGGER UPDATE
================================ */
function triggerCartUpdate() {
  clearTimeout(cartTimer);
  if (cartAnimReq) cancelAnimationFrame(cartAnimReq);
  if (isUpdatingCart) return;
  setCheckoutLoadingState(true);

  const progressBar = document.getElementById('cart-progress-bar');
  if (progressBar) {
    progressBar.style.width = '0%';
  }
  cartStartTime = performance.now();
  const DURATION = CART_UPDATE_DURATION;
  function animateProgress(now) {
    const elapsed = now - cartStartTime;
    const pct = Math.min(100, (elapsed / DURATION) * 100);
    const pBar = document.getElementById('cart-progress-bar');
    if (pBar) {
      pBar.style.width = pct + '%';
    }
    if (elapsed < DURATION) {
      cartAnimReq = requestAnimationFrame(animateProgress);
    }
  }
  cartAnimReq = requestAnimationFrame(animateProgress);

  cartTimer = setTimeout(() => {
    updateCart();
  }, DURATION);
}

/* ================================
   RECALCULAR PRECIOS
================================ */
function recalculateLinePrices() {
  document.querySelectorAll('.line-item').forEach(item => {

    const qty = parseInt(item.dataset.qtycart) || 0;

    const priceText = item.querySelector('.line-item__price')?.innerText || '';
    const clean = priceText.replace(/[^0-9]/g, '');
    const unitPrice = parseInt(clean) || 0;

    const total = unitPrice * qty;

    const linePriceEl = item.querySelector('.line-item__line-price-value');
    if (linePriceEl) {
      linePriceEl.innerText = formated_cost(total);
    }
  });
}

/* ================================
   UPDATE CART
================================ */
function updateCart() {
  if (isUpdatingCart) return;
  isUpdatingCart = true;

  const updates = {};

  document.querySelectorAll(".custom-qty-input").forEach(input => {
    const stock = parseInt(input.dataset.stock) || 999999;
    let qty = parseInt(input.value);

    if (qty > stock) {
      qty = stock;
      input.value = stock;
    }

    const key = input.closest('.line-item').dataset.key;

    if (!isNaN(qty)) {
      updates[key] = qty;
    }
  });

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  })
  .then(res => res.json())
  .then(async cart => {
    console.log("=== CART CONTROL");
    console.table(cart);
    document.querySelectorAll('.custom-qty-input').forEach(input => {
      const key = input.closest('.line-item').dataset.key;
      const item = cart.items.find(i => i.key === key);
      if (item) {
        input.value = item.quantity;
        input.dataset.initial = item.quantity;

        syncQuantity(input, item.quantity);
      }
    });

    // ===============================
    // Refrescamos precios con Shopify + AWS
    // ===============================
    const localProducts = cart.items.map(item => buildProduct({
        id: item.product_id,
        sku: item.sku,
        price: item.final_price / 100,
        original_price: item.original_price != item.final_price? item.original_price / 100 : null,
        line_price: item.final_line_price / 100,
        original_line_price: item.original_line_price / 100
    }));

    const finalProducts = await getDimercPrices(localProducts);
    console.log("=== finalProducts CART ===");
    console.table(finalProducts);

    GetPrice(finalProducts);

    // recalculateLinePrices();
    format_cart();
    initStockUI();

    isUpdatingCart = false;
    setCheckoutLoadingState(false);
  })
  .catch(err => {
    console.error("Error actualizando carrito", err);
    isUpdatingCart = false;
    setCheckoutLoadingState(false);
  });
}

function updateStockUI(container, value, stock) {
  const increaseBtn = container.querySelector('.js-increase');

  if (!increaseBtn) return;

  if (value >= stock) {
    increaseBtn.setAttribute('disabled', 'disabled');
    increaseBtn.setAttribute('aria-label', 'No queda stock');
    increaseBtn.setAttribute('data-tooltip', 'No queda stock');
    increaseBtn.setAttribute('data-tooltip-position', 'bottom-left');

    increaseBtn.style.cursor = 'not-allowed';
  } else {
    increaseBtn.removeAttribute('disabled');
    increaseBtn.removeAttribute('data-tooltip');
    increaseBtn.removeAttribute('data-tooltip-position');

    increaseBtn.style.opacity = '';
    increaseBtn.style.cursor = '';
  }
}

function initStockUI() {
  document.querySelectorAll('.quantity-selector').forEach(container => {
    const input = container.querySelector('.custom-qty-input');
    if (!input) return;

    const value = parseInt(input.value) || 0;
    const stock = parseInt(input.dataset.stock) || 999999;

    updateStockUI(container, value, stock);
  });
}


function syncPrintCart() {
    console.log("sincronizar print");
  let subtotal = 0;

  document.querySelectorAll('.line-item').forEach(item => {
    const id = item.dataset.id;
    const qty = parseInt(item.dataset.qtycart) || 0;

    const priceText = item.querySelector('.line-item__price')?.innerText || '';
    const clean = priceText.replace(/[^0-9]/g, '');
    const unitPrice = parseInt(clean) || 0;

    const total = unitPrice * qty;
    subtotal += total;

    // actualizar fila en print
    const rowPrice = document.querySelector(`.item_price_final[data-id="${id}"]`);
    if (rowPrice) {
      rowPrice.innerText = formated_cost(total);
    }

    const rowUnit = document.querySelector(`.item_price_unit[data-id="${id}"]`);
    if (rowUnit) {
      rowUnit.innerText = formated_cost(unitPrice);
    }

    const qtyEl = document.querySelector(`.item_qty[data-id="${id}"]`);
    if (qtyEl) {
      qtyEl.innerText = qty;
    }
  });

  // subtotal
  const subtotalEl = document.getElementById('print-subtotal');
  if (subtotalEl) {
    subtotalEl.innerText = formated_cost(subtotal);
  }

  // print-shipping-cost
  const totalShipping = getShippingFromPrint();
  
  const totalNeto = subtotal + totalShipping;

  // total neto
  const totalNetoEl = document.getElementById('print-totalneto');
  if (totalNetoEl) {
    totalNetoEl.innerText = formated_cost((totalNeto ));
  }
  
  // IVA
  const iva = Math.round(totalNeto * 0.19);
  const ivaEl = document.getElementById('print-currency');
  if (ivaEl) {
    ivaEl.innerText = formated_cost(iva);
  }

  // total
  const total = totalNeto + iva;
  const totalEl = document.getElementById('print-total');
  if (totalEl) {
    totalEl.innerText = formated_cost(total);
  }
  
  //recalcular pesos
  const summary = calculateCartSummary();
  const summaryEl = document.getElementById('print-weight');
  if (summaryEl) {
    summaryEl.innerHTML = `
      Este pedido contiene ${summary.totalItems} artículos. || Peso ${summary.totalWeightKg} Kg.
    `;
  }
}

function getShippingFromPrint() {
  const ship = document.querySelector('.cart-recap__price-line-price');
  if (!ship) return 0;
  console.log(ship.dataset.shippingcost);

  return parseInt(ship.dataset.shippingcost) || 0;
}

function calculateCartSummary() {
  let totalItems = 0;
  let totalWeight = 0;

  document.querySelectorAll('.line-item').forEach(item => {
    const qty = parseInt(item.dataset.qtycart) || 0;
    const weight = parseFloat(item.dataset.weight) || 0;

    totalItems += qty;
    totalWeight += (weight * qty);
  });

  // convertir a KG
  const totalWeightKg = (totalWeight / 1000).toFixed(1);

  return {
    totalItems,
    totalWeightKg
  };
}